import React from 'react';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import Button from '@atlaskit/button';
export var Header = function (_a) {
    var onClose = _a.onClose, title = _a.title, label = _a.label;
    return (React.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
        } },
        React.createElement("div", { style: { width: '28px' } }),
        React.createElement("div", null, title),
        React.createElement("div", null,
            React.createElement(Button, { appearance: "subtle", iconBefore: React.createElement(EditorCloseIcon, { label: label }), onClick: onClose }))));
};
//# sourceMappingURL=ModalHeader.js.map